import { Link } from "react-router";
import { useAppGlobStore } from "src/appGlobalStore";
import { useTheme } from "src/theme/ThemeProvider";

const Logo = () => {
  const isFreeEdition = useAppGlobStore(s => s.info.backend?.free ?? false);
  const { logoSrc } = useTheme();

  return (
    <Link className="logo" to="/" rel="noopener noreferrer">
      <div className="logo-container" style={{ marginTop: isFreeEdition ? "-10px" : 0 }}>
        <img src={logoSrc} alt="xormon_logo" height={17} />
        {isFreeEdition && <span className="logo-text">Free Edition</span>}
      </div>
    </Link>
  );
};

export default Logo;